module.exports = __webpack_public_path__ + "static/media/back-arrow-white.bd678c3e.svg";